module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-4"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-11"
  }), _vm._v(" "), _c('p', {
    staticClass: "x-1-Chapter-number"
  }), _vm._v(" "), _c('p', {
    staticClass: "x-2-chapter-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-11"
  }), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction")]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "#/Text/SCRPp1"
    }
  }, [_vm._v("Chapter One     “")]), _c('a', {
    attrs: {
      "href": "#/Text/SCRPp1"
    }
  }, [_vm._v("[They] Had Set Their Hearts Upon the Southern Cross”")]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('br')]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/Text/SCRPp2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two     ")]), _c('span', {
    attrs: {
      "href": "#/Text/SCRPp2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“It Was Soon, However, Discovered to Be a Regiment of the Enemy”")]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('br')]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/Text/SCRPp3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three  “")]), _c('span', {
    attrs: {
      "href": "#/Text/SCRPp3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It Was an Army Affair . . . I Have Always Said So”")]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('br')]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/Text/SCRPp4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four    “")]), _c('span', {
    attrs: {
      "href": "#/Text/SCRPp4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[I] First Solicited the Assistance of Mrs. James Alfred Jones”")]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('br')]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/Text/SCRPp5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five    “")]), _c('span', {
    attrs: {
      "href": "#/Text/SCRPp5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Mothers, Your Wives and Your Sisters Have Made It”")]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('br')]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/Text/SCRPp6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six      ")]), _c('span', {
    attrs: {
      "href": "#/Text/SCRPp6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Gayety Was the Most Marked Feature about Them”")]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('br')]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/Text/SCRPp7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven “")]), _c('span', {
    attrs: {
      "href": "#/Text/SCRPp7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[I] Recommend That They. . . Have ‘Perryville’ Inscribed on Their Banner”")]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/Text/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/Text/Abbreviations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('br')]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/Text/ColorAppendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographic Appendix")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")]), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', [_c('br')]), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/Text/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")]), _c('br')])])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-11"
  }), _vm._v(" "), _c('p', {
    staticClass: "x-1-Chapter-number"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246a7338","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ToC.vue
// module id = 69
// module chunks = 0